import { Button, Modal, Image } from 'antd-mobile'
import React,{useState,useRef} from 'react'
import './index.less'
import warningImg from '../../assets/pcwarning.svg'
import { CloseOutline } from 'antd-mobile-icons'
import { connect, useHistory } from 'umi'
const WarningPopup = (props:any) => {
    const {warningPopup,dispatch,loginInfo,firstShow} = props
    const history = useHistory()
    const path = history.location.pathname
    const [visible, setVisible] = useState(false)
    const onClose = () => {
        const now = new Date()
        const nowtime = now.getTime()
        localStorage.setItem('pcPopBeginTime',nowtime.toString())
        dispatch({
            type: 'headInfo/changePcWarning',
            payload:false
          })
        //   if(loginInfo.login === false && firstShow === true && path === '/'){
        //       setTimeout(()=>{
        //         dispatch({
        //             type: 'headInfo/changeinviteshow',
        //             payload: true,
        //           });
        //       },3000)
        //   }
    }

    
    return (
        <Modal
        className='pcwarning'
            visible={warningPopup}
            closeOnMaskClick
            onClose={onClose}
              content={
                <div>
                    <div className='close'>
                        <CloseOutline onClick={onClose} />
                    </div>
                    <div className='title'>
                        For the best experience ModCart is optimized for browsing on your mobile device
                    </div>
                    <div className='warningimgbox'>
                        <Image className='warningimg' src={warningImg}></Image>
                    </div>
                    <div>

                    </div>
                </div>
              }
        >
        </Modal>
    )
}
export default connect(({ headInfo }: any) => {
    return {
      ...headInfo
    };
  })(WarningPopup);